// A filter change refetches the same pull: keep its last good data on screen (and behind an error) so an
// explorer's controls never disappear; a different pull starts empty.
export const keepSamePullData = (slice, pullId) => (slice.pullId === pullId ? slice.data : null);

// Only the latest request's response may land — an earlier filter or an earlier pull must not overwrite it.
export const isStaleResponse = (slice, payload) =>
  payload.pullId !== slice.pullId || payload.requestId !== slice.requestId;
